/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ConnectionView } from './connectionView';

export type GenericApiResponseConnectionViewData = ConnectionView | null;
